export default __webpack_public_path__ + "static/media/029-horn.27742cd3.png";